import { Link } from 'react-router-dom';

import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';
import { getFontScale } from 'themes/mixins/getFontScale';

const Wrapper = styled.section`
  margin: 2rem 0;
`;

const Header = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 1.6rem;
  flex-wrap: wrap;
`;

const StatisticsLink = styled(Link)`
  ${getFontScale('s')};

  color: ${pickColor('colmarBlue')};
  text-decoration: none;
  white-space: nowrap;

  &:hover {
    text-decoration: underline;
  }
`;

export { Wrapper, Header, StatisticsLink };
